import { createSelector } from 'reselect';

const getState = (state) => state.warnings;

const getWarnings = createSelector(getState, (warnings) => warnings);

const getExternalProps = (_, { shipmentKey }) => ({
  shipmentKey,
});

const loadsInShipmentHaveWarnings = createSelector(
  getState,
  getExternalProps,
  (warnings, { shipmentKey }) =>
    Object.keys(warnings).some(
      (warningKey) => warningKey.indexOf(`shipment_${shipmentKey}_loads`) >= 0
    )
);
export default {
  getWarnings,
  loadsInShipmentHaveWarnings,
};
